exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  font-family: 'Helvetica Neue';\n  margin: 0;\n}\n\n#root {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
